import { http } from 'services'

const state = () => ({
  active: {},
  errors: null
})

const getters = {
}

const actions = {
  ['reservationActions.get'] ({ commit }, id) {
    commit('CLEAR_ERRORS')

    return http.get(`reservation-actions/${id}`)
    .then((res) => {
      commit('GET_RESERVATION_ACTION', res)
    })
    .catch((res) => {
      commit('RESERVATION_ACTIONS_ERROR', res)
    })
  }
}

const mutations = {
  GET_RESERVATION_ACTION (state, res) {
    state.active = res.data
  },

  RESERVATION_ACTIONS_ERROR (state, err) {
    try {
      state.errors = err.response.data
    } catch (e) {
      state.errors = err
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
